// import { imageList } from './images';
import AppRoutes from "./routes/AppRoutes";
import "./assets/fonts/font-style.css";
import "./styles/global.css";
import { ToastProvider } from "react-toast-notifications";
import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./store/store";

function App() {
  return (
    <>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider autoDismissTimeout={5000}>
          <AppRoutes />
        </ToastProvider>
      </PersistGate>
    </>
  );
}

export default App;
